import {
  formatDateRange,
  formatDate,
  formatTime,
  formatDateTime,
  formatDateTimeWithTimezone,
  formatTimeWithTimezone,
  formatDateWithTimezone,
  getDateFormat,
  getTimeFormat,
  getDateTimeFormat,
  getStartOfDay,
  getEndOfDay
} from '@shared/utils/date'

export default {
  install: (app) => {
    app.config.globalProperties.$date = {
      formatDateRange,
      getDateFormat,
      getTimeFormat,
      getDateTimeFormat,
      getStartOfDay,
      getEndOfDay,
      formatDate,
      formatTime,
      formatDateTime,
      formatDateWithTimezone,
      formatTimeWithTimezone,
      formatDateTimeWithTimezone
    }
  }
}
